import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Box, Button, Text, usePopoverContext } from '@bonusly/design-system';

import { useHomepageRedesignEnabled } from '../../../../../../modules/bonus-feed/features/recognition/components/BonusFeed/hooks/useHomepageRedesignEnabled';
import { useHashtagLink } from '../../../../../../modules/bonus-feed/features/recognition/hooks/useHashtagLink';
import { HashtagTrend } from '../../../types/hashtag';

interface HashtagDetailProps {
	hashtag: HashtagTrend;
}

export const HashtagDetail: FC<HashtagDetailProps> = ({ hashtag: { core_value, count, hashtag } }) => {
	const { t } = useTranslation('recognition');
	const hashtagLinkUrl = useHashtagLink(hashtag);
	const isHomepageRedesignEnabled = useHomepageRedesignEnabled();
	const navigate = useNavigate();
	const { onClose } = usePopoverContext();

	const handleClick = () => {
		onClose();
		window.scrollTo({ top: 0, behavior: 'smooth' });
		navigate(hashtagLinkUrl);
	};

	return (
		<Box>
			<Box mb={2}>
				<Text fontSize="lg" fontWeight="medium">
					{hashtag}
				</Text>

				{!!count && (
					<Text color="text.softest" fontSize="sm">
						{t('sidebar.trending.mentions_count', { count, context: 'full' })}
					</Text>
				)}
			</Box>

			{core_value && (
				<Text data-testid="core-value-description" color="text.softer" fontSize="md" mb={4} whiteSpace="pre-wrap">
					{core_value.description}
				</Text>
			)}

			{isHomepageRedesignEnabled ? (
				<Button variant="alpha" w="full" onClick={handleClick}>
					{t('sidebar.trending.view_hashtag_button')}
				</Button>
			) : (
				<Button as="a" href={hashtagLinkUrl} variant="alpha" w="full">
					{t('sidebar.trending.view_hashtag_button')}
				</Button>
			)}
		</Box>
	);
};
